module.exports = __webpack_public_path__ + "app-static/img/p_08.a986223a.jpg";